import { render, staticRenderFns } from "./AreaSidebar.vue?vue&type=template&id=5995b998&scoped=true&"
import script from "./AreaSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./AreaSidebar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AreaSidebar.vue?vue&type=style&index=0&id=5995b998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995b998",
  null
  
)

export default component.exports